export default "/images/c3c48e12becf9928ac4ac301c409e035.png";